import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { forwardRef, Fragment, useEffect, useRef, useState } from 'react';
import { DOMAIN } from '../../config';
import { Box, DialogContent, styled } from '@mui/material';
import CustomizedProgressBars from '../common/loading';
import TextList from '../common/textList';
import { getRandom } from '../../funcs';
import SearchDialog from '.';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SeriesMenuDialog({openSeriesMenu,setOpenSeriesMenu,matches,chipTitle}) {
  const [latest,setLatest] = useState(null)
  const latestRef = useRef(latest)
  const [page,setPage] = useState(1)
  const [loading,setLoading] = useState(false)
  const dialogRef = useRef(null)
  const [stopLoad,setStopLoad] = useState(false)
  const [empty,setEmpty] = useState(false)
  const [openSearch, setOpenSearch] = useState(false)
  const [searchTitle, setSearchTitle] = useState(null)
  const touchStartRef = useRef(0);

  const handleSwipe = (event) => {
    const touchEndX = event.changedTouches[0].clientX;
    const swipeDistance = touchStartRef.current - touchEndX;

    if (swipeDistance > 120) { // 设定滑动距离阈值
      setOpenSeriesMenu(false)
    }
  };

  const handleTouchStart = (event) => {
    touchStartRef.current = event.touches[0].clientX;
  };

  const handleClose = () => {
    setOpenSeriesMenu(false);
  };

  const handleScroll = () => {
    if(stopLoad) return
    // const { scrollTop, scrollHeight, clientHeight } = dialogRef.current
    // if (scrollTop +1+ clientHeight >= scrollHeight) {
    //     setLoading(true)
    //     fetch(`${DOMAIN}ywyminiappbot/serieslist`)
    //     .then((response)=>response.json())
    //     .then((data)=>{
    //         if(data.length == 0 || data.length < 5) {
    //           setStopLoad(true)
    //         }
    //         setPage(page+1)
    //         console.log("page"+page)
    //         setLatest([...latest,...data])
    //         setLoading(false)
    //     })

    // }
    
  }

  useEffect(()=>{
    if(!openSeriesMenu) return
    setLoading(true)

    fetch(`${DOMAIN}ywyminiappbot/serieslist`)
    .then((response)=>response.json())
    .then((data)=>{
      setLoading(false)

        setLatest(data)

    })
  },[openSeriesMenu])

  return (
    <Fragment >
      <SearchDialog 
                chipTitle={searchTitle}
                openSearch={openSearch} 
                setOpenSearch={setOpenSearch} 
                matches={matches}
      />
      <Dialog 
        fullScreen
        open={openSeriesMenu}
        onClose={handleClose}
        TransitionComponent={Transition}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleSwipe}
        PaperProps={{
          onTouchStart: handleTouchStart,
          onTouchEnd: handleSwipe,
        }}
      >
        <AppBar sx={{ position: 'sticky' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {chipTitle}
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent
          ref={dialogRef}
          onScroll={handleScroll}
          style={{
            padding:0
          }}
        >
      
        {latest && 
            latest.map(item=>(
                <TextList
                    key={`seriesList${getRandom()}`}
                    latest={item}
                    openSearch={openSearch}
                    setOpenSearch={setOpenSearch}
                    setSearchTitle={setSearchTitle}
                />
            ))
        }
        {
          empty && <Box style={{
            display:"flex",
            justifyContent:"center",
            flexFlow:"row",
            padding:"200px 0",
            color:"#999"
          }}>
            <SearchOffIcon/>
            <Typography variant='h6' fontSize={14}>没有此内容，我们会尽快发布...</Typography>
          </Box>
        }
        {loading&&<CustomizedProgressBars/>}
        {stopLoad&&
            <Typography variant='h6' style={{
              fontSize:12,
              paddingBottom:20,
              textAlign:"center",
              color:"#888",
              fontWeight:350
            }}>已经是最后一条了～</Typography>
        }
        
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}